import { useIntl } from 'react-intl';
import React from 'react'
import { Questionnaire } from 'src/types/questionnaire';

export function anatomySpecialityFilterOptions() {
    const intl = useIntl();
    return [
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.regions' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.systems' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.complete' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.sections' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.allergy' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.cardiology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.odontology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.dermatology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.endocrinology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.gastroenterology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.infectious' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.nephrology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.neurology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.obstetrics' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.oncology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.ophthalmology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.orthopedics' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.otorhinolaryngology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.pediatrics' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.pneumology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.rheumatology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.AnatomySpeciality_filter.urology' })
    ];
}

export function typeFilterOptions() {
    const intl = useIntl();
    return [
        intl.formatMessage({ id: 'utils.UtilsConstants.TypeFilter_filter.anatomy' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.TypeFilter_filter.disease' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.TypeFilter_filter.physology' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.TypeFilter_filter.procedure' })
    ];
}

export function levelOfDetailFilterOptions() {
    const intl = useIntl();
    return [
        intl.formatMessage({ id: 'utils.UtilsConstants.LevelOfDetail_filter.gross' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.LevelOfDetail_filter.tissue' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.LevelOfDetail_filter.cellular' }),
        intl.formatMessage({ id: 'utils.UtilsConstants.LevelOfDetail_filter.molecular' })
    ];
}

export function getMaxScoreQuestionnaire(questionnaire: Questionnaire) {
    const scoreType = questionnaire.scoreType;
    switch (scoreType) {
        case 'PHQ-9':
            return 27;
        case 'PHQ-A':
            return 27;
        case 'EUROQOL-5D':
            return 1;
        case 'PITTSBURG':
            return null;
        case 'YESAVAGE':
            return null;
        case 'AUDIT':
            return 40;
        case 'CRAFFT':
            return questionnaire.questionnaire_choices_question_list.length
        case 'PREDIMED':
            return questionnaire.questionnaire_choices_question_list.length;
        case 'EVA':
            return 10;
        case 'GAD-7':
            return 21;
        case 'WHO-5':
            return 100;
        case 'PROMIS-GH':
            return 55;
        case 'CAPE-P15':
            return 3;
        case 'SCOFF':
            return 5;
        case 'M-CHAT':
            return 23;
        case 'VANDERBILT':
            return null;
        case 'ASQ':
            return 33;
        case 'SDI':
            return 10;
        case 'FAGERSTROM':
            return 10;
        case 'SATED':
            return 10;
        case 'PITTSBURG-CHOICES':
            return 21;
        case 'IPAQ-SF':
            return 100000;
        case 'IPA':
            return 135;
        case 'PSS':
            return 40;
        default:
            return null;
    }
}

export const numberOfSubcriptionsInLeftMenu = 4;